import { EApplications } from 'core/model/enums/channel.enum';
import type { IModulesNavigationPlatform } from 'core/model/interfaces/module-navigation.interface';
import type { IGetModuleNavigationResponseDTO } from './module-navigation.dto';

export const transformModuleNavigation = (data: IGetModuleNavigationResponseDTO): Array<IModulesNavigationPlatform> => [
  { platformId: EApplications.GENERAL, modules: data.modules },
  ...data.applications.map(app => ({
    platformId: app.id,
    modules: app.modules,
  })),
];
